<h2 class="mb-10">Confirmação</h2>
<p class="mb-5">A vaga {{data.vaga.tituloVaga}} é apenas divulgada no Conecta, você será redirecionado para outra plataforma para finalizar a sua inscrição.</p>
<p class="mb-5">Deseja continuar?</p>
<div class="button-container">
    <button type="button" class="btn btn-light" (click)="onNoClick()">Não</button>
    <button type="button" class="btn btn-primary" (click)="onYesClick()">Sim</button>
</div>
